export default function Logo({ light = false, className = "" }) {
    return (
        <span className={`inline-flex items-center gap-3 ${className}`}>
            <img
                src={light ? "/addigen-logo-white.png" : "/addigen-logo.png"}
                alt="AddiGen logo"
                className="h-9 w-auto object-contain sm:h-10"
                width="40"
                height="40"
            />
            <span
                className={`font-display text-lg font-bold tracking-[0.12em] ${light ? "text-white" : "text-ink"}`}
            >
                ADDIGEN
            </span>
        </span>
    );
}
